import React, { useState, useRef, useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import "./POffer.css";
import { axiosInstances } from "./apiConfig";

const OfferQuotationEditable = ({ offerData, onPreview, onCancel }) => {
    const [ofrnum, setofrnum] = useState(offerData.ofrnum);
    const [offerDate, setOfferDate] = useState(offerData.offerDate);
    const [igst, setIgst] = useState(offerData.igst * 100);
    const [cgst, setCgst] = useState(offerData.cgst * 100);
    const [sgst, setSgst] = useState(offerData.sgst * 100);
    const [authorizedBy, setAuthorizedBy] = useState(offerData.authorizedBy);
    const [enquiryId, setEnquiryId] = useState(offerData.enquiryId || "");
    const [customer, setcustomer] = useState(offerData.customer || {});
    const [items, setItems] = useState(offerData.items || []);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [offerStatus, setOfferStatus] = useState(offerData.offer_status || "Open");
    const [subTotal, setSubTotal] = useState(offerData.subTotal);
    const [grandTotal, setGrandTotal] = useState(offerData.grandTotal);
    const [company, setCompany] = useState({
        name: "My Company Pvt Ltd",
        address: "123 Main Street",
        city: "Hyderabad",
        state: "Telangana",
        zip: "500001",
        phone: "040-12345678",
        email: "info@mycompany.com"
    });
    const [terms, setTerms] = useState(offerData.terms || `
        1. Payment is due within 30 days from the invoice date.
        2. Prices mentioned are exclusive of applicable taxes unless specified.
        3. Delivery timelines are indicative and subject to confirmation at the time of order.
        4. Warranty will be provided as per the product specifications.
        5. Any claims for damaged goods must be reported within 7 days of delivery.
        6. The company reserves the right to modify the quotation validity period.
        7. Returns and replacements will follow the company’s standard policy.
        8. Confidentiality of the quotation and related information must be maintained.
        9. Any disputes arising will be resolved under Hyderabad jurisdiction.
        10. Acceptance of this quotation implies acceptance of all terms and conditions mentioned herein.`)

    useEffect(() => {
        if (offerData) {
            setofrnum(offerData.ofrnum || "");
            setOfferDate(offerData.offerDate || new Date().toISOString().split("T")[0]);
            setIgst((offerData.igst || 0.18) * 100);
            setCgst((offerData.cgst || 0.09) * 100);
            setSgst((offerData.sgst || 0.09) * 100);
            setAuthorizedBy(offerData.authorizedBy || {});
            setEnquiryId(offerData.enquiryId || "");
            setcustomer(offerData.customer || {});
            setItems(offerData.items || []);
            setOfferStatus(offerData.offer_status || "Open");
            setCompany(offerData.company || {});
            setTerms(offerData.terms || "");
            setTerms(
                offerData.terms && offerData.terms.trim() !== ""
                    ? offerData.terms
                    : `
                    1. Payment is due within 30 days from the invoice date.
                    2. Prices mentioned are exclusive of applicable taxes unless specified.
                    3. Delivery timelines are indicative and subject to confirmation at the time of order.
                    4. Warranty will be provided as per the product specifications.
                    5. Any claims for damaged goods must be reported within 7 days of delivery.
                    6. The company reserves the right to modify the quotation validity period.
                    7. Returns and replacements will follow the company’s standard policy.
                    8. Confidentiality of the quotation and related information must be maintained.
                    9. Any disputes arising will be resolved under Hyderabad jurisdiction.
                    10. Acceptance of this quotation implies acceptance of all terms and conditions mentioned herein.
                    `
            );
        }
    }, [offerData]);

    const handleCompanyChange = (e) => {
        setCompany({ ...company, [e.target?.name]: e.target.value });
    };

    const handlecustomerChange = (e) => {
        setcustomer({ ...customer, [e.target?.name]: e.target.value });
    };

    const handleItemChange = (index, field, value) => {
        const newItems = [...items];
        if (field === "quantity" || field === "amount") {
            value = Number(value);
            if (isNaN(value)) value = 0;
        }
        newItems[index][field] = value;
        setItems(newItems);
    };

    const handleTermChange = (e) => {
        setTerms(e.target.value);
    };

    const handleAuthorizedChange = (e) => {
        setAuthorizedBy({ ...authorizedBy, [e.target?.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const shippingState =
            customer?.addresses?.find(a => a.addressType === "Shipping")?.state || "";

        const isTelangana = shippingState.trim().toLowerCase() === "telangana";

        // Extract Billing & Shipping details
        const Billing = customer?.addresses?.find(a => a.addressType === "Billing") || {};
        const Shipping = customer?.addresses?.find(a => a.addressType === "Shipping") || {};

        const subTotal = offerData.items.reduce((sum, item) => sum + item.quantity * item.amount, 0);

        const normalizeTax = (value) => (value > 1 ? value / 100 : value);

        const newigst = isTelangana ? normalizeTax(igst) : 0;
        const newcgst = isTelangana ? 0 : normalizeTax(cgst);
        const newsgst = isTelangana ? 0 : normalizeTax(sgst);

        const grandTotal = subTotal + subTotal * (newigst + newsgst + newcgst);

        // Prepare preview data

        onPreview({
            id: offerData.id || null,
            enquiryId,
            customerId: customer.id,
            productIds: items.map(item => item.id),
            company,
            customer: {
                ...customer,
                BillingAddress: {
                    address_1: Billing.address_1 || "",
                    city: Billing.city || "",
                    state: Billing.state || "",
                    pincode: Billing.pincode || "",
                },
                ShippingAddress: {
                    address_1: Shipping.address_1 || "",
                    city: Shipping.city || "",
                    state: Shipping.state || "",
                    pincode: Shipping.pincode || "",
                },
            },
            ofrnum,
            offerDate,
            items,
            igst: newigst,
            cgst: newcgst,
            sgst: newsgst,
            terms,
            subTotal,
            grandTotal,
            authorizedBy,
            offer_status: offerData.offer_status || "Open",
        });
    };

    const fetchEnquiry = async () => {
        if (!enquiryId) return;

        try {
            const resp = await axiosInstances.enquiryApi.get(`/${enquiryId}`);
            const data = resp.data.data;

            if (data) {
                const customer = data.customer || {};

                const addresses = customer.addresses || [];

                // Separate Billing & Ship
                const Billing = addresses.find(a => a.addressType === "Billing") || {};
                const Shipping = addresses.find(a => a.addressType === "Shipping") || {};

                const customerInfo = {
                    id: customer.id || "",
                    name: customer.name || "",
                    email: customer.email || "",
                    phone: customer.phone || "",
                    BillingAddress: {
                        address_1: Billing.address_1 || "",
                        city: Billing.city || "",
                        state: Billing.state || "",
                        pincode: Billing.pincode || "",
                    },
                    ShippingAddress: {
                        address_1: Shipping.address_1 || "",
                        city: Shipping.city || "",
                        state: Shipping.state || "",
                        pincode: Shipping.pincode || "",
                    },
                    addresses: addresses, // keep all addresses for backend
                };

                const offerItems = (data.products || []).map((p) => ({
                    id: p.id,
                    code: p.id || "",
                    description: p.description || "",
                    quantity: 1,
                    amount: p.amount || 0,
                    total: p.total || 0,
                }));

                const companyInfo = data.company || company;

                setCompany(companyInfo);
                setcustomer(customerInfo);
                setItems(offerItems);

            }
        } catch (err) {
            console.error("❌ Error fetching enquiry:", err);
            setSnackbar({
                open: true,
                message: "Failed to fetch enquiry data",
                severity: "error",
            });
        }
    };



    return (
        <form onSubmit={handleSubmit} className="container">
            <h1 className="title">Offer</h1>
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8, marginRight: 68 }}>
                <strong>Enquiry ID:</strong>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
                {offerData?.id ? (
                    // ✅ Edit Mode – show readonly Enquiry ID
                    <input
                        type="text"
                        value={enquiryId}
                        readOnly
                        style={{ width: "50px", marginRight: 90, padding: "4px", backgroundColor: "#f0f0f0", cursor: "not-allowed" }}
                    />
                ) : (
                    // 🆕 Create Mode – show editable input + search button
                    <>
                        <input
                            type="text"
                            placeholder="Enquiry Id"
                            value={enquiryId}
                            style={{ width: "100px", padding: "4px" }}
                            onChange={(e) => setEnquiryId(e.target.value)}
                        />
                        <button
                            type="button"
                            onClick={fetchEnquiry}
                            style={{ marginLeft: -1, height: "30px", padding: "4px 10px" }}
                        >
                            🔍
                        </button>
                    </>
                )}
            </div>


            <div className="header">
                <div className="company-info">
                    <h3>Company Info</h3>
                    <label>
                        Name:<br />
                        <input type="text" name="name" value={company?.name} onChange={handleCompanyChange} className="input" />
                    </label>
                    <br />
                    <label>
                        Address:<br />
                        <input type="text" name="address" value={company?.address} onChange={handleCompanyChange} className="input" />
                    </label>
                    <br />
                    <label>
                        City:<br />
                        <input type="text" name="city" value={company?.city} onChange={handleCompanyChange} className="input" />
                    </label>
                    <br />
                    <label>
                        State:<br />
                        <input type="text" name="state" value={company?.state} onChange={handleCompanyChange} className="input" />
                    </label>
                    <br />
                    <label>
                        ZIP:<br />
                        <input type="text" name="zip" value={company?.zip} onChange={handleCompanyChange} className="input" />
                    </label>
                    <br />
                    <label>
                        Phone:<br />
                        <input type="text" name="phone" value={company?.phone} onChange={handleCompanyChange} className="input" />
                    </label>
                    <br />
                    <label>
                        Email:<br />
                        <input type="email" name="email" value={company?.email} onChange={handleCompanyChange} className="input" />
                    </label>
                </div>

                <div className="customer-info">
                    <h3>customer Info</h3>
                    <label>
                        Name:<br />
                        <input
                            type="text"
                            name="name"
                            value={customer?.name}
                            onChange={handlecustomerChange}
                            className="input"
                        />
                    </label>
                    <br />
                    <label>
                        Email:<br />
                        <input
                            type="email"
                            name="email"
                            value={customer?.email || ""}
                            onChange={handlecustomerChange}
                            className="input"
                        />
                    </label>
                    <br />
                    <label>
                        Phone:<br />
                        <input
                            type="text"
                            name="phone"
                            value={customer?.phone || ""}
                            onChange={handlecustomerChange}
                            className="input"
                        />
                    </label>

                    {/* --- Billing To --- */}
                    <div style={{ marginTop: 20, paddingTop: 10 }}>
                        <h4>Billing To:</h4>
                        <input
                            type="text"
                            placeholder="Address Line"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Billing")?.address_1 || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const BillingIndex = newAddresses.findIndex(a => a.addressType === "Billing");
                                if (BillingIndex >= 0)
                                    newAddresses[BillingIndex].address_1 = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Billing",
                                        address_1: e.target.value,
                                        city: "",
                                        state: "",
                                        pincode: ""
                                    });
                                setcustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="City"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Billing")?.city || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const BillingIndex = newAddresses.findIndex(a => a.addressType === "Billing");
                                if (BillingIndex >= 0)
                                    newAddresses[BillingIndex].city = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Billing",
                                        address_1: "",
                                        city: e.target.value,
                                        state: "",
                                        pincode: ""
                                    });
                                setcustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="State"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Billing")?.state || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const BillingIndex = newAddresses.findIndex(a => a.addressType === "Billing");
                                if (BillingIndex >= 0)
                                    newAddresses[BillingIndex].state = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Billing",
                                        address_1: "",
                                        city: "",
                                        state: e.target.value,
                                        pincode: ""
                                    });
                                setcustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="Pincode"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Billing")?.pincode || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const BillingIndex = newAddresses.findIndex(a => a.addressType === "Billing");
                                if (BillingIndex >= 0)
                                    newAddresses[BillingIndex].pincode = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Billing",
                                        address_1: "",
                                        city: "",
                                        state: "",
                                        pincode: e.target.value
                                    });
                                setcustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                    </div>

                    {/* --- Ship To --- */}
                    <div style={{ marginTop: 20, paddingTop: 10 }}>
                        <h4>Ship To:</h4>
                        <input
                            type="text"
                            placeholder="Address Line"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Shipping")?.address_1 || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const ShippingIndex = newAddresses.findIndex(a => a.addressType === "Shipping");
                                if (ShippingIndex >= 0)
                                    newAddresses[ShippingIndex].address_1 = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Shipping",
                                        address_1: e.target.value,
                                        city: "",
                                        state: "",
                                        pincode: ""
                                    });
                                setcustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="City"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Shipping")?.city || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const ShippingIndex = newAddresses.findIndex(a => a.addressType === "Shipping");
                                if (ShippingIndex >= 0)
                                    newAddresses[ShippingIndex].city = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Shipping",
                                        address_1: "",
                                        city: e.target.value,
                                        state: "",
                                        pincode: ""
                                    });
                                setcustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="State"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Shipping")?.state || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const ShippingIndex = newAddresses.findIndex(a => a.addressType === "Shipping");
                                if (ShippingIndex >= 0)
                                    newAddresses[ShippingIndex].state = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Shipping",
                                        address_1: "",
                                        city: "",
                                        state: e.target.value,
                                        pincode: ""
                                    });
                                setcustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                        <br />
                        <input
                            type="text"
                            placeholder="Pincode"
                            value={
                                customer?.addresses?.find(a => a.addressType === "Shipping")?.pincode || ""
                            }
                            onChange={(e) => {
                                const newAddresses = [...(customer.addresses || [])];
                                const ShippingIndex = newAddresses.findIndex(a => a.addressType === "Shipping");
                                if (ShippingIndex >= 0)
                                    newAddresses[ShippingIndex].pincode = e.target.value;
                                else
                                    newAddresses.push({
                                        addressType: "Shipping",
                                        address_1: "",
                                        city: "",
                                        state: "",
                                        pincode: e.target.value
                                    });
                                setcustomer({ ...customer, addresses: newAddresses });
                            }}
                            className="input"
                        />
                    </div>
                </div>
            </div>

            <p>
                <label>
                    <strong>Offer No: </strong>
                    <input type="text" value={ofrnum} onChange={(e) => setofrnum(e.target.value)} className="input-small" />
                </label>
                <br />
                <label>
                    <strong>Offer Date: </strong>
                    {/* <input type="date" value={new Date().toISOString().split("T")[0]} onChange={(e) => setOfferDate(e.target.value)} className="input-small" /> */}
                    <input
                        type="date"
                        value={offerDate || new Date().toISOString().split("T")[0]}
                        onChange={(e) => setOfferDate(e.target.value)}
                        className="input-small"
                    />
                </label>
                <br />
                {/* <div style={{ marginTop: 10, marginBottom: 20 }}> */}
                <label>
                    <strong>Offer Status:</strong>
                    <select
                        value={offerStatus}
                        onChange={(e) => setOfferStatus(e.target.value)}
                    >
                        <option value="Open">Open</option>
                        <option value="Accept">Accept</option>
                        <option value="Decline">Decline</option>
                    </select>
                </label>
                {/* </div> */}
            </p>

            <table className="table">
                <thead>
                    <tr>
                        <th className="th">Product ID</th>
                        <th className="th">Description</th>
                        <th className="th">Quantity</th>
                        <th className="th">Unit Price (INR)</th>
                        <th className="th">Total Price (INR)</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, i) => (
                        <tr key={i}>
                            <td className="td">
                                <input
                                    type="text"
                                    value={item.code}
                                    onChange={(e) => handleItemChange(i, "code", e.target.value)}
                                    className="input-table"
                                />
                            </td>

                            <td className="td">
                                <textarea
                                    ref={(el) => {
                                        if (el) {
                                            el.style.height = "auto";
                                            el.style.height = el.scrollHeight + "px";
                                        }
                                    }}
                                    value={item.description}
                                    onChange={(e) => handleItemChange(i, "description", e.target.value)}

                                    className="input-table"
                                    style={{
                                        overflow: "hidden",
                                        resize: "none",
                                    }}
                                    rows={1}
                                    onInput={(e) => {
                                        e.target.style.height = "auto";
                                        e.target.style.height = e.target.scrollHeight + "px";
                                    }}
                                />
                            </td>
                            <td className="td"> <input value={item.quantity} onChange={(e) => handleItemChange(i, "quantity", e.target.value)} className="input-table" /> </td>
                            <td className="td">
                                <input
                                    value={item.amount}
                                    onChange={(e) => handleItemChange(i, "amount", e.target.value)}
                                    className="input-table"
                                />
                            </td>
                            <td className="td">
                                {(item.quantity * item.amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {(customer?.addresses?.find(a => a.addressType === "Shipping")?.state || ""
            ).trim().toLowerCase() === "telangana" ? (
                <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <label>
                        IGST (%):{" "}
                        <input
                            value={igst}
                            onChange={(e) => setIgst(Number(e.target.value))}
                            className="input-small"
                        />
                    </label>
                </div>
            ) : (
                <>
                    <div style={{ marginTop: 20, marginBottom: 10 }}>
                        <label>
                            CGST (%):{" "}
                            <input
                                value={cgst}
                                onChange={(e) => setCgst(Number(e.target.value))}
                                className="input-small"
                            />
                        </label>
                    </div>
                    <div style={{ marginBottom: 20 }}>
                        <label>
                            SGST (%):{" "}
                            <input
                                value={sgst}
                                onChange={(e) => setSgst(Number(e.target.value))}
                                className="input-small"
                            />
                        </label>
                    </div>
                </>
            )}
            {/* <div>subTotal: ₹{(offerData.subTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
            <div>Total: ₹{(offerData.grandTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div> */}


            <div style={{ marginBottom: '16px' }}>
                <h3>Terms and Conditions</h3>
                <textarea
                    id="terms"
                    name="terms"
                    ref={(el) => {
                        if (el) {
                            el.style.height = 'auto';
                            el.style.height = el.scrollHeight + 'px';
                        }
                    }}
                    rows={1}
                    style={{
                        width: '100%',
                        padding: '8px',
                        resize: 'vertical',
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                    }}
                    value={terms}
                    onChange={(e) => {
                        handleTermChange(e);
                        e.target.style.height = 'auto';
                        e.target.style.height = e.target.scrollHeight + 'px';
                    }}
                />

            </div>

            <div style={{ marginTop: 40 }}>
                <h3>Authorized By</h3>
                <label>
                    Name:<br />
                    <input type="text" name="name" value={authorizedBy?.name} onChange={handleAuthorizedChange} className="input" />
                </label>
                <br />
                <label>
                    Position:<br />
                    <input type="text" name="position" value={authorizedBy?.position} onChange={handleAuthorizedChange} className="input" />
                </label>
                <br />
                <label>
                    Company:<br />
                    <input type="text" name="company" value={authorizedBy?.company} onChange={handleAuthorizedChange} className="input" />
                </label>
            </div>

            <div style={{ marginTop: 30, textAlign: "center" }}>
                <button type="submit" className="save-button">
                    Preview Offer
                </button>{" "}
                {onCancel && (
                    <button type="button" onClick={onCancel} className="cancel-button">
                        Cancel
                    </button>
                )}
            </div>
        </form>
    );
};

const OfferQuotation = ({ offerData, onEdit, onPrint, onSave }) => {
    const subTotal = offerData.items.reduce((sum, item) => sum + item.quantity * item.amount, 0);

    const grandTotal = subTotal + subTotal * (offerData.igst + offerData.cgst + offerData.sgst);

    function convertToInputDateFormat(dateStr) {
        if (!dateStr || !dateStr.includes("-")) return "";
        const [dd, mm, yyyy] = dateStr.split("-");
        return `${yyyy}-${mm}-${dd}`;
    }

    const formatDate = (inputDate) => {
        if (!inputDate) return "";
        const [year, month, day] = inputDate.split("-");
        return `${day}-${month}-${year}`;
    };

    return (
        <div className="container" id="print-section">
            <h1 className="title">Offer</h1>

            <div className="header">
                <div className="company-info">
                    <strong>{offerData?.company?.name}</strong>
                    <br />
                    {offerData?.company?.address}
                    <br />
                    {offerData?.company?.city}
                    <br />
                    {offerData?.company?.state}
                    <br />
                    {offerData?.company?.zip}
                    <br />
                    Phone: {offerData?.company?.phone}
                    <br />
                    Email: {offerData?.company?.email}
                </div>
                <div className="customer-info">
                    <strong>To:</strong>
                    <br />
                    {offerData.customer?.name}
                    <br />
                    <strong>Billing Address:</strong><br />
                    {offerData.customer?.BillingAddress?.address_1}<br />
                    {offerData.customer?.BillingAddress?.city}<br />
                    {offerData.customer?.BillingAddress?.state}<br />
                    {offerData.customer?.BillingAddress?.pincode}<br />

                    <br />
                    <strong>Shipping Address:</strong><br />
                    {offerData.customer?.ShippingAddress?.address_1}<br />
                    {offerData.customer?.ShippingAddress?.city}<br />
                    {offerData.customer?.ShippingAddress?.state}<br />
                    {offerData.customer?.ShippingAddress?.pincode}
                </div>

            </div>

            <p>
                <strong>Offer No:</strong> {offerData.ofrnum}
                <br />
                <strong>Date:</strong> {formatDate(offerData.offerDate)}
                <br />
                <strong>Status:</strong> {offerData.offer_status}
            </p>

            <table className="table">
                <thead>
                    <tr>
                        <th className="th">Product ID</th>
                        <th className="th">Description</th>
                        <th className="th">Quantity</th>
                        <th className="th">Unit Price (INR)</th>
                        <th className="th">Total Price (INR)</th>
                    </tr>
                </thead>
                <tbody>
                    {(offerData?.items || []).map((item, i) => (
                        <tr key={i}>
                            <td className="td">{item.code}</td>
                            {/* <td style={{ ...styles.td, padding: 0 }}> */}
                            <td className="td" style={{ padding: 0 }}>
                                <div
                                    className="input-table"
                                    style={{
                                        whiteSpace: "pre-wrap",
                                        wordWrap: "break-word",
                                        padding: 8,
                                        minHeight: 34, // match textarea line height
                                        // border: "1px solid #ccc",
                                    }}

                                >
                                    {item.description}
                                </div>
                            </td>

                            <td className="td">{item.quantity}</td>
                            <td className="td">{item.amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td className="td">
                                {(item.quantity * item.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="totals">
                <div>subTotal: ₹{subTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                {offerData.igst > 0 ? (
                    <div>
                        IGST ({(offerData.igst * 100).toFixed(2)}%): ₹
                        {(subTotal * offerData.igst).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                    </div>
                ) : (
                    <>
                        <div>
                            CGST ({(offerData.cgst * 100).toFixed(2)}%): ₹
                            {(subTotal * offerData.cgst).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}
                        </div>
                        <div>
                            SGST ({(offerData.sgst * 100).toFixed(2)}%): ₹
                            {(subTotal * offerData.sgst).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}
                        </div>
                    </>
                )}

                <div>Total: ₹{grandTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
            </div>

            <div className="terms" style={{ whiteSpace: 'pre-wrap' }}>
                <h3>Terms and Conditions</h3>
                {offerData.terms}
            </div>

            <div className="authorized">
                <strong>Authorized By:</strong>
                <br />
                {offerData.authorizedBy?.name}
                <br />
                {offerData.authorizedBy?.position}
                <br />
                {offerData.authorizedBy?.company}
            </div>

            <div style={{ marginTop: 30, textAlign: "center" }} className="no-print">
                <button onClick={onSave} className="save-button">
                    {offerData?.id ? "Update" : "Save"}
                </button>
                {" "}
                <button onClick={onEdit} className="edit-button">
                    Edit
                </button>{" "}
                <button onClick={onPrint} className="print-button">
                    Print
                </button>
            </div>
        </div>
    );
};

export default function OfferQuotationApp({ offerId, onCancel }) {
    const blankData = {
        enquiryId: "",
        company: {
            name: "My Company Pvt Ltd",
            address: "123 Main Street",
            city: "Hyderabad",
            state: "Telangana",
            zip: "500001",
            phone: "040-12345678",
            email: "info@mycompany.com",
        },
        customer: {
            name: "",
            address: "",
            city: "",
            state: "",
            zip: "",
        },
        ofrnum: "",
        offerDate: new Date().toISOString().split("T")[0],
        offer_status: "Open",   // ✅ Add this line
        items: [{ code: "", description: "", quantity: 0, amount: 0 }],
        igst: 0.18,
        cgst: 0.09,
        sgst: 0.09,
        subTotal: 0,
        grandTotal: 0,
        terms: "",
        authorizedBy: { name: "", position: "", company: "" },
    };

    const [offerData, setOfferData] = useState(blankData);
    const [isEditing, setIsEditing] = useState(true);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });


    const handlePreview = (data) => {
        setOfferData(data);
        setIsEditing(false);
    };

    function convertToInputDateFormat(dateStr) {
        if (!dateStr || !dateStr.includes("-")) return "";
        const [dd, mm, yyyy] = dateStr.split("-");
        return `${yyyy}-${mm}-${dd}`;
    }

    const formatDate = (inputDate) => {
        if (!inputDate) return "";
        const [year, month, day] = inputDate.split("-");
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        if (!offerId) return; // Create new offer


        axiosInstances.offerApi.get(`/${offerId}`)
            .then((resp) => {
                const data = resp.data.data;
                if (!data) return;

                const offer = data.offer;
                const customer = data.customer || {};
                const products = data.products || [];
                const prices = data.prices || [];
                const defaultCompany = {
                    name: "My Company Pvt Ltd",
                    address: "123 Main Street",
                    city: "Hyderabad",
                    state: "Telangana",
                    zip: "500001",
                    phone: "040-12345678",
                    email: "info@mycompany.com"
                };

                // merge products + prices
                const items = products.map((p) => {
                    const price = prices.find(pr => pr.productId === p.id);
                    return {
                        id: p.id,
                        priceId: price?.id || null,
                        code: p.id,
                        description: p.description,
                        quantity: price?.quantity || 1,
                        amount: price?.amount || 0,
                    };
                });

                setOfferData((prev) => ({
                    ...prev,
                    id: offer.id,
                    enquiryId: offer.enquiryId,
                    customer: customer,
                    company: {
                        ...defaultCompany,
                        ...(offer.company || {})
                    },
                    items,
                    ofrnum: offer.ofrnum || "",
                    offerDate: convertToInputDateFormat(offer.offerDate),
                    offer_status: offer.offer_status || "Open",
                    igst: offer.igst || 0.18,
                    cgst: offer.cgst || 0.09,
                    sgst: offer.sgst || 0.09,
                    subTotal: offer.subTotal || 0,
                    grandTotal: offer.grandTotal || 0,
                    terms: offer.terms || "",
                    authorizedBy: offer.authorizedBy || offerData.authorizedBy,
                }));

                console.log("✅ Offer loaded successfully", offer);
            })
            .catch((err) => {
                console.error("❌ Error loading offer:", err);
            });
    }, [offerId]);

    const printRef = useRef();

    const handleSave = async () => {
        try {

            const subTotal = offerData.items.reduce((sum, i) => sum + i.quantity * i.amount, 0);
            const grandTotal = subTotal + subTotal * (offerData.igst + offerData.cgst + offerData.sgst);

            const payload = {
                ...offerData,
                id: offerData.id, // make sure id is carried in the payload
                prices: offerData.items.map(i => ({
                    id: i.priceId || null,
                    productId: i.id,
                    quantity: i.quantity,
                    amount: i.amount,
                    total: i.amount * i.quantity,
                }),

                ),
                offerDate: formatDate(offerData.offerDate), // keep conversion if backend expects dd-MM-yyyy
                subTotal,
                grandTotal,
            };

            let resp;

            if (offerData.id && offerData.id !== 0) {
                resp = await axiosInstances.offerApi.post(`/update`, payload);
            } else {
                resp = await axiosInstances.offerApi.post(`/save`, payload);
            }

            setOfferData(prev => ({
                ...prev,
                ...(resp.data.data?.offer || resp.data.data || {}),
            }));

            setSnackbar({
                open: true,
                message: offerData.id ? "Offer updated successfully!" : "Offer created successfully!",
                severity: "success",
            });

            if (onCancel) {
                setTimeout(() => onCancel(), 1000);
            }
        } catch (err) {
            console.error("❌ Error saving offer:", err);
            setSnackbar({
                open: true,
                message: "Failed to save offer. Check console for details.",
                severity: "error",
            });
        }
    };


    const handleEdit = () => setIsEditing(true);
    const handlePrint = () => window.print();
    const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

    return (
        <>
            {isEditing ? (
                <OfferQuotationEditable
                    offerData={offerData}
                    onPreview={handlePreview}
                    onCancel={onCancel}
                />
            ) : (
                <OfferQuotation
                    offerData={offerData}
                    onEdit={handleEdit}
                    onPrint={handlePrint}
                    onSave={handleSave}
                />
            )}

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}